(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-detail-accordions"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var hasIncluded = document.querySelector('.bek-product-accordion--included');
    var hasDownloads = document.querySelector('.bek-product-accordion--downloads');
    var hasSafety = document.querySelector('.bek-product-accordion--safety');

    if (!hasIncluded && !hasDownloads && !hasSafety) {
      return;
    }

    function isSectionStart(element) {
      return /^H[2-4]$/.test(element.tagName);
    }

    function isHeadingLike(element) {
      if (isSectionStart(element)) {
        return true;
      }
      return element.tagName === 'P' && element.textContent.trim().length < 100 && element.querySelector('strong, b');
    }

    function removeSection(element) {
      var next = element.nextElementSibling;
      element.remove();

      while (next) {
        var current = next;
        next = next.nextElementSibling;

        if (isSectionStart(current)) {
          break;
        }

        current.remove();
      }
    }

    document.querySelectorAll('.bek-description-source').forEach(function (source) {
      source.querySelectorAll('h2, h3, h4, p').forEach(function (element) {
        if (!element.isConnected || !isHeadingLike(element)) {
          return;
        }

        var text = element.textContent.trim().toLowerCase();

        if (hasIncluded && text.indexOf('lieferumfang') !== -1) {
          removeSection(element);
          return;
        }

        if (hasDownloads && text.indexOf('download') !== -1) {
          removeSection(element);
          return;
        }

        if (hasSafety && text.indexOf('sicherheit') !== -1) {
          removeSection(element);
        }
      });
    });
  });
  if (!window.bekDownloadHandlerBound) {
    window.bekDownloadHandlerBound = true;
    document.addEventListener('click', async function (event) {
      var link = event.target.closest('[data-bek-download]');
      if (!link) return;

      event.preventDefault();
      if (link.getAttribute('aria-busy') === 'true') return;

      link.setAttribute('aria-busy', 'true');

      try {
        var response = await fetch(link.href, { mode: 'cors', credentials: 'omit' });
        if (!response.ok) throw new Error('Download fehlgeschlagen');

        var blob = await response.blob();
        var objectUrl = URL.createObjectURL(blob);
        var trigger = document.createElement('a');
        trigger.href = objectUrl;
        trigger.download = link.dataset.bekFilename || 'download';
        trigger.hidden = true;
        document.body.appendChild(trigger);
        trigger.click();
        trigger.remove();
        window.setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1500);
      } catch (error) {
        var fallback = document.createElement('a');
        fallback.href = link.href;
        fallback.download = link.dataset.bekFilename || 'download';
        fallback.rel = 'noopener';
        fallback.hidden = true;
        document.body.appendChild(fallback);
        fallback.click();
        fallback.remove();
      } finally {
        link.removeAttribute('aria-busy');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["withdrawal-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var calendars = document.querySelectorAll('[data-withdrawal-datepicker]');
    if (!calendars.length) return;

    var monthNames = [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    ];

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function sameDay(a, b) {
      return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }

    calendars.forEach(function (root) {
      var display = root.querySelector('.withdrawal-date__display');
      var hidden = root.querySelector('input[type="hidden"]');
      var panel = root.querySelector('.withdrawal-calendar');
      var label = root.querySelector('[data-calendar-label]');
      var days = root.querySelector('[data-calendar-days]');
      var selected = null;
      var view = new Date();
      view.setDate(1);

      function close() {
        panel.hidden = true;
        display.setAttribute('aria-expanded', 'false');
      }

      function open() {
        panel.hidden = false;
        display.setAttribute('aria-expanded', 'true');
        render();
      }

      function render() {
        var today = new Date();
        var firstDay = new Date(view.getFullYear(), view.getMonth(), 1);
        var startOffset = (firstDay.getDay() + 6) % 7;
        var totalDays = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();

        label.textContent = monthNames[view.getMonth()] + ' ' + view.getFullYear();
        days.innerHTML = '';

        for (var blank = 0; blank < startOffset; blank += 1) {
          days.appendChild(document.createElement('span'));
        }

        for (var day = 1; day <= totalDays; day += 1) {
          var current = new Date(view.getFullYear(), view.getMonth(), day);
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'withdrawal-calendar__day';
          button.textContent = day;

          if (sameDay(current, today)) button.classList.add('is-today');
          if (sameDay(current, selected)) button.classList.add('is-selected');

          button.addEventListener('click', function (event) {
            var chosen = new Date(view.getFullYear(), view.getMonth(), Number(event.currentTarget.textContent));
            selected = chosen;
            display.value = pad(chosen.getDate()) + '.' + pad(chosen.getMonth() + 1) + '.' + chosen.getFullYear();
            hidden.value = chosen.getFullYear() + '-' + pad(chosen.getMonth() + 1) + '-' + pad(chosen.getDate());
            close();
          });

          days.appendChild(button);
        }
      }

      root.querySelector('[data-calendar-prev]').addEventListener('click', function () {
        view.setMonth(view.getMonth() - 1);
        render();
      });

      root.querySelector('[data-calendar-next]').addEventListener('click', function () {
        view.setMonth(view.getMonth() + 1);
        render();
      });

      display.addEventListener('click', open);
      display.addEventListener('focus', open);
      root.querySelector('.withdrawal-date__trigger').addEventListener('click', open);

      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) close();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') close();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
